import React from "react";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import ClockhashLogo from "../Assets/clockhash-logo.png"; // Adjust the path as necessary
import { useNavigate } from "react-router-dom";

const TopNavBar = ({ uuid }) => {
    const navigate = useNavigate();

    return (
        <AppBar
            position="absolute"
            sx={{
                backgroundColor: "rgba(133, 133, 133, 0.2)",
                backdropFilter: "blur(7px)", // Added blur effect
                margin: "22px 32px", // Centered horizontally
                left: 0,
                right: 0,
                width: "calc(100% - 65px)", // Adjusted width to account for margins
                borderRadius: "24px", // Removed shadow
                border: "1px solid rgba(166, 166, 166, 0.3)", // Added border
                height: "60px", // Reduced height by 20% (default AppBar height is 80px)
                "@media (max-width: 600px)": {
                    margin: "10px", // Reduce margins for mobile
                    width: "calc(100% - 20px)", // Adjust width for mobile
                },
            }}
        >
            <Toolbar sx={{ minHeight: "64px", padding: "0 16px" }}>
                {" "}
                {/* Adjusted Toolbar height */}
                <Box sx={{ flexGrow: 1, display: "flex", alignItems: "center" }}>
                    <img
                        src={ClockhashLogo}
                        alt="Logo"
                        style={{
                            height: "50px",
                            marginRight: "10px",
                            cursor: "pointer",
                            "@media (max-width: 600px)": {
                                height: "40px", // Smaller logo on mobile
                            },
                        }}
                        onClick={() => navigate(`/portfolio/${uuid}`)} // Navigate to the main page
                    />
                </Box>
                <Button
                    variant="contained"
                    color="primary"
                    sx={{
                        textTransform: "capitalize",
                        backgroundColor: "rgba(0, 0, 0, 0.4)",
                        "&:hover": { backgroundColor: "rgba(0, 0, 0, 0.7)" },
                        borderRadius: "10px",
                        fontSize: { xs: "0.75rem", sm: "0.875rem" }, // Adjust font size for mobile and desktop
                        padding: { xs: "8px 10px", sm: "10px 13px" }, // Adjust padding for mobile and desktop
                        "@media (max-width: 600px)": {
                            fontSize: "0.75rem", // Smaller font size for mobile
                            padding: "8px 12px", // Adjust padding for mobile
                        },
                    }}
                    onClick={() =>
                        window.open(
                            "https://calendly.com/marketing-clockhash/introduction-call",
                            "_blank"
                        )
                    }
                >
                    Contact Us
                </Button>
            </Toolbar>
        </AppBar>
    );
};

export default TopNavBar;
